module.exports = __webpack_public_path__ + "img/cotImage.838980a7.svg";